export const MAX_EVENT_INACTIVITY_MINUTES = 7 * 24 * 60;

export const eventAutoCloseMinutesError = value => {
  if (value === '' || value === null || value === undefined) return null;

  const minutes = Number(value);
  if (!Number.isInteger(minutes)) return 'not_integer';
  if (minutes < 1) return 'below_minimum';
  if (minutes > MAX_EVENT_INACTIVITY_MINUTES) return 'above_maximum';

  return null;
};
